export { default } from './dist/vue-mathjax.common'
export * from './dist/vue-mathjax.common'
